import {FC} from "react";
import Image, {ImageProps} from "next/legacy/image";
import googleBucketLoader from "../../lib/google-bucket-loader";
import clone from "lodash/clone";
import {Box, Typography} from "@mui/material";

interface ImgProps extends ImageProps {
    title?: string
}

export const Img: FC<ImageProps> = (props) => {

    //take note that the rehypeImgSize remark plugin that automatically gets image sizes for markdown images
    // the plugin is upstream in content.ts

    const newProps = clone(props)

    if (!props.width || !props.height) {
        newProps.layout = props.layout || "fill"
        // newProps.width = "100%"
        // newProps.height= "auto"
        // newProps.fill = true
        newProps.style = {
            // position: "unset", // cannnot set position with "fill"
            objectFit: "contain"
        }
    }


    return <Box component={"span"}><Image loader={googleBucketLoader}
                       {...newProps}
                       src={props.src || "/images/placeholder/1280x853.png"}
    />
        {newProps.title && <Typography variant={"caption"}
                                       textAlign={"center"}
                                       component={"span"}
                                       display={"block"}>{newProps.title}</Typography>}
     </Box>

}
